import { Injectable } from '@angular/core';
import { LoadingController, AlertController } from 'ionic-angular';

@Injectable()
export class CommonProvider {
       public loader: any;
       constructor(public loadingCtrl: LoadingController,
                   private alertCtrl: AlertController,
                  ) {
         console.log('Hello Common Provider');
     }

     presentLoading(){
      this.loader = this.loadingCtrl.create({content: "Carregando ..."})
      this.loader.present();
     }

     closeLoading(){
      this.loader.dismiss();
     }

     presentAlert(text: any) {
      let alert = this.alertCtrl.create({
        title: 'Atenção',
        subTitle: text,
        buttons: ['Dismiss']
      });
      alert.present();
    }


     verificarToken(data: any) {

        if (data.status === 401) {

         this.presentAlert('Login expirado, favor logar novamente!');

         return 'LoginPage';

        }

    }

}



// WEBPACK FOOTER //
// ./src/providers/common/common.ts